// extracted by mini-css-extract-plugin
module.exports = {"container":"i_SF","header":"i_SG","icon":"i_SH","label":"i_SI","heading":"i_SJ","subheading":"i_SK"};